import { Observable, of as observableOf } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { WebPortal } from '@gk/gk-modules';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { catchError, combineLatestWith, map } from 'rxjs/operators';
import { RedirectToGrantingRightsModalComponent } from '../../components/ask-for-redirect-to-granting-rights/redirect-to-granting-rights-modal.component';
import { SessionService } from '../../services/session/session.service';
import { WebPortalService } from '../../services/web-portal/web-portal.service';
import { MainRoutes } from '../guard.models';

@Injectable()
export class ClientSgkGuard {
  private path: MainRoutes;
  private webPortal: WebPortal;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private webPortalService: WebPortalService,
    private ngbModal: NgbModal,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.path = this.getRoutePath(route);
    return this.sessionService.loggedUserData.pipe(
      combineLatestWith(
        this.webPortalService.getWebPortalDataByCurrentRoute(this.path),
      ),
      map(([loggedUser, webPortal]) => {
        this.webPortal = webPortal;
        if (loggedUser.clientSgk) {
          return true;
        }
        this.handleNoClientSgkInfo();

        return false;
      }),
      catchError(() => observableOf(false)),
    );
  }

  getRoutePath(route: ActivatedRouteSnapshot): MainRoutes {
    return _.get(route.url, '[0].path', '') as MainRoutes;
  }

  handleNoClientSgkInfo(): void {
    this.webPortalService
      .isPortalAvailableForGrantingRights(this.webPortal.portalId)
      .subscribe((isPortalAvailable) => {
        if (isPortalAvailable) {
          this.showModalAskingForRedirectToGrantingRights();
        } else {
          this.showNoClientSgkInfo();
          this.sessionService.logOffSystemSession().subscribe();
          this.router.navigate([MainRoutes.OfficeDepartmentsPortal]);
        }
      });
  }

  showModalAskingForRedirectToGrantingRights(): void {
    const modal = this.ngbModal.open(RedirectToGrantingRightsModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    const componentInstance: RedirectToGrantingRightsModalComponent =
      modal.componentInstance;
    componentInstance.i18nObjectName =
      'REDIRECT_TO_GRANTING_RIGHTS_DUE_TO_NO_SGK_CLIENT';
    componentInstance.portalId = this.webPortal.portalId;
  }

  showNoClientSgkInfo(): void {
    this.translateService.get('NO_CLIENT_SGK_INFO').subscribe((text) =>
      this.toastr.warning(text, null, {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
      }),
    );
  }
}
